module.exports = __webpack_public_path__ + "return-right-arrow.17f7f87ea6d283af9608856dffa2cb0d.svg";